import {useEffect, useState} from "react";
import {useApi} from "@/lib/api";

export const usePagingApi = (options) => {
  const { url, params: initParams = {} } = options;
  const [params, setParams] = useState(initParams);
  const [results, setResults] = useState();
  const resolvedFetcher = options.fetcher
    ? () => options.fetcher(params)
    : undefined;
  const { data, isLoading, error , ...rest } = useApi({
    ...options,
    params,
    fetcher: resolvedFetcher,
  });

  useEffect(() => {
    if (isLoading) return;
    if (error) {
      setResults(undefined);
      return;
    }
    if (data && data.results) setResults(data);
  }, [isLoading, data, error]);

  return {
    data: results,
    error,
    params,
    setParams,
    isLoading,
    ...rest
  };
};
